import { render, staticRenderFns } from "./TopBox.vue?vue&type=template&id=bf3491ba&scoped=true&"
import script from "./TopBox.vue?vue&type=script&lang=js&"
export * from "./TopBox.vue?vue&type=script&lang=js&"
import style0 from "./TopBox.vue?vue&type=style&index=0&id=bf3491ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3491ba",
  null
  
)

export default component.exports